/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UpdateVideoDto } from '../../models/update-video-dto';
import { VideoDto } from '../../models/video-dto';

export interface VideoControllerUpdate$Params {
  id: string;
      body: UpdateVideoDto
}

export function videoControllerUpdate(http: HttpClient, rootUrl: string, params: VideoControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<VideoDto>> {
  const rb = new RequestBuilder(rootUrl, videoControllerUpdate.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<VideoDto>;
    })
  );
}

videoControllerUpdate.PATH = '/api/videos/{id}';
